const FALLBACK_SKELETON_ROW_COUNT = 7;

export function getSkeletonRowCount(dataLength: number): number {
  return dataLength > 0 ? dataLength : FALLBACK_SKELETON_ROW_COUNT;
}
